export default __webpack_public_path__ + "static/underline-1-f349527bb1c0fcf8edfc88233f0a1a9c.png";